import { get, post } from './http'



export const getMainShop = p => post('/app/getMainShop.do', p);


export const getJixiaoSuccess = p => post('/aftersale/yewu/getJixiaoSuccess.do', p);
export const getdclthSuccess = p => post('/sale/yewu/primary/getAsPrimary.do', p);
export const setLingqu = p => post('/sale/yewu/primary/setLingqu.do', p);
export const getAsPrimaryNum = p => post('/sale/yewu/primary/getAsPrimaryNum.do ', p);
export const setLingquAll = p => post('/sale/yewu/primary/setLingquAll.do', p);

export const getAsRenwu = p => post('/sale/yewu/renwu/getAsRenwu.do', p);
export const getAsJixiaoDay = p => post('/sale/yewu/jixiao/getAsJixiaoDay.do', p);
export const getAsJixiaoShop = p => post('/sale/yewu/jixiao/getAsJixiaoShop.do', p);
export const getAsJixiaoKefu = p => post('/sale/yewu/jixiao/getAsJixiaoKefu.do', p);
export const getAsPayBack = p => post('/sale/yewu/renwu/getAsPayBack.do', p);
export const updateAsPayBack = p => post('/sale/yewu/renwu/updateAsPayBack.do', p);
export const renweuupdateFeige = p => post('/sale/yewu/renwu/updateFeige.do', p);
export const renweuupdateTel = p => post('/sale/yewu/renwu/updateTel.do', p);
export const afterSale_updateBeizhu = p => post('/sale/yewu/renwu/updateBeizhu.do', p);







export const getDecryptTel = p => post('/sale/yewu/DecryptTelOne/getDecryptTel.do', p);
export const asGrant_amountUpdate = p => post('/sale/yewu/renwu/AsGrant_amountUpdate/update.do', p);
export const getRgcpQueryOrdersChuji = p => post('/comment/yewu/primary/query/getRgcpQueryOrdersChuji.do', p);
export const taskOrders = p => post('/comment/yewu/RgcpTaskOrders/taskOrders.do', p);//同步订单
export const getRGCPOrdersSize = p => post('/comment/yewu/primary/query/getRGCPOrdersSize.do', p);//piliang领取获取数量
export const delOrder = p => post('/comment/yewu/primary/del/delOrder.do', p);//piliang删除
export const lingquAll = p => post('/remark/yewu/primary/lingqu/lingquAll.do', p);//post('/comment/yewu/primary/lingqu/lingquAll.do', p);//piliang领取
export const lingqu = p => post('/remark/yewu/lingqu/lingqu/lingqu.do', p);//post('/comment/yewu/lingqu/lingqu/lingqu.do', p);//piliang领取
export const getRgcp_Renwu_Q = p => post('/comment/yewu/renwu/query/getRgcp_Renwu_Q.do', p);//已领取催好评任务列表
export const order_getRgcp_Renwu_Q = p => post('/remark/yewu/renwu/feige/getRgcp_Renwu_Qfeige.do', p);//h获取领取 的订单列表
export const testgetRgcp_Renwu_Q = p => post('/remark/yewu/renwu/query/getRgcp_Renwu_Q.do', p);//已领取催好评任务列表
export const getKefu = p => post('/comment/yewu/kefu/getKefu.do', p);//已领取催好评任务列表
export const comment_getDecryptTel = p => post('/comment/decrypt/getDecryptTel.do', p);//jiemidianhua
export const comment_updateBeizhu = p => post('/comment/yewu/renwu/link/updateBeizhu.do', p);//修改备注
export const comment_PLupdateBeizhu = p => post('/comment/yewu/renwu/beizhu/update.do', p);//all修改备注
export const comment_getRgcpJixiaoTime = p => post('/comment/yewu/jixiao/getRgcpJixiaoTime.do', p);//催评绩效表
export const comment_upPingjig = p => post('/comment/yewu/pingjia/uploadXsl/upPingjig.do', p);//上传评价数据
export const comment_getComment = p => post('/rgcp/yewu/RgcpPingjiaTaskWork/getComment.do', p);//同步评价数据
export const comment_getRGCPKefuJixiao = p => post('/comment/yewu/jixiao/getRGCPKefuJixiao.do', p);//
export const comment_getRGCPYeji = p => post('/comment/yewu/jixiao/getRGCPYeji.do', p);//
export const comment_updateOrder = p => post('/comment/yewu/renwu/link/updateOrder.do', p);//点击复制订单号的时候调用的链接
export const comment_updateFeige = p => post('/comment/yewu/renwu/link/updateFeige.do', p);//点击飞鸽沟通的时候调用的链接
export const comment_getTaskTme = p => post('/comment/yewu/pingjia/plugTask/getTaskTme.do', p);//点击同步评价的链接
export const comment_delOrder = p => post('/comment/yewu/renwu/query/delOrder.do', p);//批量删除
export const comment_addCpItem = p => post('/comment/yewu/primary/query/addCpItem.do', p);//未领取待售后订单添加...
export const comment_delCpItem = p => post('/comment/yewu/primary/query/delCpItem.do', p);//未领取待售后订单删除...
export const comment_getCpItem = p => post('/comment/yewu/primary/query/getCpItem.do', p);//未领取待售后订单获取...
export const comment_getDecryptTelMore = p => post('/comment/decrypt/getDecryptTelMore.do', p);//已领取 查看更多
export const comment_getDecryptToken = p => post('/comment/decrypt/getDecryptToken.do', p);//获取前端解密token
export const comment_maxgetDecryptToken = p => post('/comment_max/decrypt/getDecryptToken.do', p);//获取前端解密token
export const comment_getData = p => post('/comment/plug/getData.do', p);//解密前端
export const comment_getCkJixiaoTime = p => post('/comment/yewu/ck/getCkJixiaoTime.do', p);//催款业务
export const comment_getCkKefuJixiao = p => post('/comment/yewu/ck/getCkKefuJixiao.do', p);//催款业务
export const comment_getCkYeji = p => post('/comment/yewu/ck/getCkYeji.do ', p);//催款业务
 
export const paichu_delOrder = p => post('/remark/yewu/renwu/query/delOrder.do', p);//单个排除




/*   Sms  */
export const getWeixinQr_code = p => post('/main/yewu/qiyeweixin/WeixinQr_code/getWeixinQr_code.do', p);//wechat
export const getChpTemplate = p => post('/sms/yewu/smscuiping/PCpTemplateGet/getChpTemplate.do', p);//获取模板列表
export const getDuanxinNum = p => post('/sms/yewu/smscuiping/ChpDuanxinCountAllget/getDuanxinNum.do', p);//duanxinshu
export const qFeeVice = p => post('/sms/yewu/smscuiping/fee/qFeeVice.do', p);//fee
export const getSmsItems = p => post('/sms/yewu/smscuiping/ChpItem/getSmsItems.do', p);//shangpin list
export const addProCuiping = p => post('/sms/yewu/smscuiping/ProCuipingAdd/addProCuiping.do', p);//create
export const updateChpObjparame = p => post('/sms/yewu/smscuiping/ChpObjparameUpdate/updateChpObjparame.do', p);//shangpin list


export const getChpObj = p => post('/sms/yewu/smscuiping/ChpObjGet/getChpObj.do', p);//listpage listact
export const delChpObj = p => post('/sms/yewu/smscuiping/ChpObjDel/delChpObj.do', p);//del act listpage
export const updateChpObj = p => post('/sms/yewu/smscuiping/ChpObjUpdate/updateChpObj.do', p);//switch
export const getChpObjOlny = p => post('/sms/yewu/smscuiping/ChpObjOlnyGet/getChpObjOlny.do', p);//pro in act 
export const getLog = p => post('/sms/yewu/smscuiping/ChpObjSendLog/getLog.do', p);//fasong list 
export const getSmsShopShortLink = p => post('/sms/yewu/smscuiping/getSmsShopShortLink.do', p);//获取短信中链接



/****sms fee */
export const ali_trade_precreate = p => post('/main/pay/alipay/ali_trade_precreate.do', p);//获取充值二维码
export const smsFeeQFee = p => post('/main/yewu/smscuiping/fee/qFee.do', p);//liebiao
export const delshopId_vice = p => post('/main/yewu/smscuiping/fee/del.do', p);//del shareshop
export const shopName_viceadd = p => post('/main/yewu/smscuiping/fee/add.do', p);//add shareshop
export const taskSaleOrder = p => post('/sms/yewu/taskSaleOrder.do', p);// taskSaleOrder
export const smsFeeGetRgcp_Renwu_Q = p => post('/feige/comment/getRgcp_Renwu_Q.do', p);// smsFeeGetRgcp_Renwu_Q
export const SendSms = p => post('/feige/SendSms', p); 
export const sendSmsPoorComment = p => post('/feige/SendSms/sendSmsPoorComment.do', p); 
export const CPMsgaddTemplate = p => post('/feige/sms/addTemplate.do', p); 
export const CPMsggetTemplate = p => post('/feige/sms/getTemplate.do', p); 
export const CPMsgdelTemplate = p => post('/feige/sms/delTemplate.do', p); 







/**dzmd */

 
export const getPrintListShopNetsiteNEW = p => post('/remark/yewu/print/getCancelOrder.do', p);//电子面单列表
export const getPrintListShopNetsite = p => post('/print/yewu/paizhi/getPrintListShopNetsite.do', p);//电子面单列表
export const getCustomTemplateList = p => post('/print/yewu/paizhi/getCustomTemplateList.do', p);//电子面单muban
export const delMdTemplatePro = p => post('/print/yewu/paizhi/delMdTemplatePro.do', p);//del电子面单muban
export const updateMdTemplate = p => post('/print/yewu/paizhi/updateMdTemplate.do', p);//del电子面单muban
export const getTemplateList = p => post('/print/yewu/paizhi/getTemplateList.do', p);//get add电子面单muban
export const addPrTemplate = p => post('/print/yewu/paizhi/addPrTemplate.do', p);//add电子面单muban
export const getPrTemplate = p => post('/print/yewu/paizhi/getPrTemplate.do', p);//huoqu电子面单muban
export const getPrTemplateNEW = p => post('/remark/yewu/print/templates/getListShopNetsite.do', p);//huoqu电子面单muban
export const delPrTemplate = p => post('/print/yewu/paizhi/delPrTemplate.do', p);//del电子面单muban
export const tijiaoprint = p => post('/remark/yewu/print/backprint.do', p);//tijiao打印数据
export const updateTemplates = p => post('/remark/yewu/print/templates/updateTemplates.do', p);//微调打印模板
export const getTemplates = p => post('/remark/yewu/print/templates/getTemplates.do', p);//获取微调数据
export const delCancelOrder = p => post('/remark/yewu/print/delCancelOrder.do', p);//miandanhuishou



/*print */

export const getPrintOrderS = p => post('/print/yewu/order/getPrintOrderS.do', p);//
export const getPrintProvince = p => post('/print/yewu/paizhi/getPrintProvince.do', p);//省
export const getPrintProvinceNEW = p => post('/remark/yewu/print/templates/getProvince.do', p);//省
export const getPrintAreasByProvince = p => post('/print/yewu/paizhi/getPrintAreasByProvince.do ', p);//市
export const getPrintAreasByProvinceNEW = p => post('/remark/yewu/print/templates/getAreasByProvince.do', p);//市
export const delAddress = p => post('/remark/yewu/print/templates/delSendInfo.do', p);//市

export const getPrintOrderE = p => post('/print/yewu/order/getPrintOrderE.do', p);//
export const addPrintlogistics = p => post('/print/yewu/order/addPrintlogistics.do', p);//
export const setPrintWayBill = p => post('/print/yewu/order/setPrintWayBill.do', p);//打印快递
export const getPrSendInfo = p => post('/print/yewu/PrintSend/getPrSendInfo.do', p);//调取发货信息
export const getPrSendInfoNEW = p => post('/remark/yewu/print/templates/getSendInfo.do', p);//调取发货信息
export const updatePrSendInfo = p => post('/print/yewu/PrintSend/updatePrSendInfo.do', p);//保存发货信息
export const updatePrSendInfoNEW = p => post('/remark/yewu/print/templates/setSendInfo.do', p);//保存发货信息
export const getPrintConfig = p => post('/print/yewu/paizhi/getPrintConfig.do', p);//配置信息获取



 

/*******jyman建议用 */


export const getAsTongjiQ = p => post('/sale/yewu/tongji/getAsTongjiQ.do', p);//打印快递



/**** kfsale */
export const getSaleTKShuju = p => post('/sale/yewu/AfterSaleShuju/getShuju.do', p);//gezhuangtai shuliang
export const getSale_GetAll = p => post('/sale/yewu/AfterSaleAll/getAll.do', p);//gezhuangtai shuliang





/*************datainfo */
export const getSjShopNum = p => post('/sj/yewu/getSjShopNum.do', p);//
export const getSjItemList = p => post('/sj/yewu/getSjItemList.do', p);//
export const updateSjItem = p => post('/sj/yewu/updateSjItem.do', p);




/***********飞鸽消息 */
//export const uploadImage = p => post('/feige/plan/imgUp.do', p);
let remark = '/remark/yewu'
export const uploadImage = p => post(remark+'/feige/shop/getPostdata.do', p);
export const feigeMessageTemp = p => post(remark+'/feige/plan/addFeigePlan.do', p);
export const getFeigePlan = p => post(remark+'/feige/plan/getFeigePlan.do', p); 
export const getFeigePlanPro = p => post(remark+'/feige/plan/getFeigePlanPro.do', p);
export const updateFeigePlanPro = p => post(remark+'/feige/plan/updateFeigePlanPro.do', p);
export const delFeigePlanPro = p => post(remark+'/feige/plan/delFeigePlanPro.do', p);
export const addFeigeOrder = p => post(remark+'/feige/plan/addFeigeOrder.do', p);
export const getFeigeOrder = p => post(remark+'/feige/plan/getFeigeOrder.do', p);
export const getFeigeOpen = p => post(remark+'/feige/shop/getFeigeOpen.do', p);
export const updateFeigeOpen = p => post(remark+'/feige/shop/updateFeigeOpen.do', p);


/***************************************
中差评
*******************/
export const getCommentSale = p => post('/remark/yewu/CommentSale/getCommentSale.do', p);
export const zcpUpdateFeige = p => post('/remark/yewu/CommentSale/updateFeige.do', p);
export const zcpupdateTel = p => post('/remark/yewu/CommentSale/updateTel.do', p);
export const piliangbeizhuActUrl = p => post('/remark/yewu/CommentSale/update.do', p);
export const dangebeizhuActUrl = p => post('/remark/yewu/CommentSale/updateBeizhu.do', p);




















